import React from 'react';
import styled from 'styled-components';

const ContactUsGrid = styled.div`
  display: grid;
  font-family: 'Whitney Book', Arial, sans-serif;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  grid-column-gap: 30px;
  grid-row-gap: 1rem;
  justify-items: center;
  text-align: left;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 865px) {
    grid-template-columns: minmax(0, 1fr);
  }

  .contact-option {
    display: flex;
    align-items: center;
    padding: 0 1rem;
    max-width: 100%;
    box-sizing: border-box;

    a {
      font-family: 'Whitney Bold';
      white-space: nowrap;
    }

    h3 {
      font-family: 'Whitney Medium', Arial, sans-serif;
    }

    p {
      color: #272727;
      font-family: 'Whitney Book', Arial, sans-serif;
      white-space: nowrap;
      margin: 0;
      padding: 0;
    }

    img {
      height: 28px;
      margin-right: 8px;
      flex-shrink: 0;
    }
  }
`;

export const ContactUs = ({ forVets }) => (
  <ContactUsGrid>
    <div className="contact-option">
      <img src="https://cdn.prod2.platinumcloud.io/client_portal_images/phone-retina.png" />
      <div>
        <p>
          Call{' '}
          {forVets ? (
            <a href="tel:18665532400">866-553-2400</a>
          ) : (
            <a href="tel:18005532400">800-553-2400</a>
          )}
        </p>
      </div>
    </div>
    <div className="contact-option">
      <img src="https://cdn.prod2.platinumcloud.io/client_portal_images/speech-bubbles.png" />
      <div>
        <p>
          Text <a href="sms:+18339975250">833-997-5250</a>
        </p>
      </div>
    </div>
    <div className="contact-option">
      <img src="https://cdn.prod2.platinumcloud.io/client_portal_images/clock-solid.png" />
      <div>
        <p>M-F 6am-5pm Pacific</p>
      </div>
    </div>
  </ContactUsGrid>
);
